import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import axios from 'axios';
import Vuex from 'vuex';
import store from './store.js';
import './assets/style.css';

import question from './components/question.vue';
import boxType from './components/QuestionType/boxType.vue';
import inputType from './components/QuestionType/inputType.vue';

import loader from './components/loader.vue';
import previousButton from './components/previousButton.vue';
import breadcrumb from './components/breadcrumb/breadcrumb.vue';
import stepsTemplate from './components/stepsTemplate.vue';
import result from './components/Result.vue';
import gallery from './components/gallery.vue';
import i18n from './i18n';
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
/* import specific icons */
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* add icons to the library */
library.add(faCircleQuestion)
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(Vuex);
Vue.use(VueI18n);

Vue.component('loader', loader);
Vue.component('previousButton', previousButton);
Vue.component('breadcrumb', breadcrumb);
Vue.component('stepsTemplate', stepsTemplate);
Vue.component('result', result);
Vue.component('question', question);
Vue.component('boxType', boxType);
Vue.component('inputType', inputType);
Vue.component('gallery', gallery)

new Vue({
  store,
  el: '#app',
  i18n,
  render: h => h(App),
  created(){
    this.$store.commit('giveStoreInit')
  }

});